import { ReactElement } from 'react'
import FormCollapsibleSection from './FormCollapsibleSection'
import { CollapsibleBoxSectionProps } from './collapsibleSectionProps'
import { FormSectionIcons } from './icons'

interface Props extends CollapsibleBoxSectionProps {
  label?: string
}

const CollapsibleAssemblyBoxSection = ({
  children,
  label = 'Aufbau',
  defaultExpanded = true,
  dataCy,
  isEmpty,
}: Props): ReactElement | null => {
  return (
    <FormCollapsibleSection
      label={label}
      startIcon={FormSectionIcons.assembly}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      isEmpty={isEmpty}
    >
      {children}
    </FormCollapsibleSection>
  )
}

export default CollapsibleAssemblyBoxSection
